import ApiConstant from "../../constants/api.constants";
import api from "../api";
 
const getMyOrders = async (filter: string) => {  
    try {
        const Orders: any = await api
        .get(ApiConstant.getMyOrderList + filter)
        .then((result: any)=> {
            if(result)            
                return result.data;
            else
                return null;        
         })
         .catch(function (error: any) {
             console.error('error reading get my orders.', error);
         });
        const response = Orders != null ? Orders : null;        
        return response;
    }
    catch (e) {
        console.log('error in getMyOrders');
        return [];
    }
}
 
const getMyOrders1 = async (filters: {
    Year: number;
    PageNumber: number;
    PageSize: number;
    Keyword?: string | null;
}): Promise<any> => {  
    try {
        const requestBody = {
            Year: filters.Year,
            PageNumber: filters.PageNumber,
            PageSize: filters.PageSize,
            Keyword: filters.Keyword || null,
        };
        const response = await api.post(ApiConstant.getMyOrderList1, requestBody)
            .then((result: any) => {
                if (result) {
                    return result.data;
                }
                return null;
            })
            .catch((error: any) => {
                console.error('Error fetching orders:', error);
                throw error;
            });
 
        return response || [];
    }
    catch (e) {
        console.error('Error in getMyOrders:', e);
        return [];
    }
};
 
const updateOrderStatus = async (data: any) => {
    try {
        const res: any = await api
        .put(ApiConstant.updateOrderStatus, data)
        .then((result: any)=> {
            if(result)            
                return result.data;
            else
                return null;        
         })
         .catch(function (error: any) {
             console.error('error updating order status', error);
         });
        const response = res != null ? res : null;        
        return response;
    }
    catch
    {
        console.log('error in update order status');
        return false;
    }
}
const GetCancelledOrders = async (filters: {
    phoneNumber?: string;
    startDate?: Date;
    endDate?: Date;
    pageNumber?: number;
    pageSize?: number;
}): Promise<any> => {  
    try {
        const formatDate = (date?: Date) => {
            if (!date) return null;
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            return `${year}-${month}-${day}`;
        };
        const requestBody = {
            phoneNumber: filters.phoneNumber,
            startDate: formatDate(filters.startDate),
            endDate: formatDate(filters.endDate),
            pageNumber: filters.pageNumber,
            pageSize: filters.pageSize
        };
 
        const response = await api.post(ApiConstant.getCancelledOrders, requestBody);
       
        if (response.data) {
            return {
                data: response.data.canceledOrderList || [],
                totalRecords: response.data.totalRecords || 0
            };
        }
       
        return { data: [], totalRecords: 0 };
    }
    catch (e) {
        console.error('Error in cancelled orders:', e);
        return { data: [], totalRecords: 0 };
    }
};
 
const getProductwiseOrders = async (filters: {
    Year: number;
    PageNumber: number;
    PageSize: number;
    Keyword?: string | null;
}): Promise<any> => {  
    try {
        const requestBody = {
            Year: filters.Year,
            PageNumber: filters.PageNumber,
            PageSize: filters.PageSize,
            Keyword: filters.Keyword || null,
        };
 
        const response = await api.post(ApiConstant.getProductwiseOrders, requestBody)
            .then((result: any) => result?.data || [])
            .catch((error: any) => {
                console.error('Error fetching productwise orders:', error);
                throw error;
            });
 
        return response;
    } catch (e) {
        console.error('Error in getProductwiseOrders:', e);
        return [];
    }
};
 
 
 
 
const myOrderServices = {
    getMyOrders,
    updateOrderStatus,
    getMyOrders1,
    GetCancelledOrders,
    getProductwiseOrders  
};
 
export default myOrderServices;
 